import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Profile } from '../../models/profile';
import { CandidateService } from '../../services/candidate.service';
import { ApplicantFilter } from '../../interfaces/filters';

@Injectable()
export class  ProfileNoLocationStore {
  private _profile: BehaviorSubject<Profile[]> = new BehaviorSubject([]);
  private _page: BehaviorSubject<number> = new BehaviorSubject(1);
  private _total: BehaviorSubject<number> = new BehaviorSubject(0);
  private _loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _lastPage: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private page: number;
  private total: number;
  private filter:ApplicantFilter;
  private pagecount: number;

  constructor(private candidateBackendService: CandidateService) {
    //this.loadInitialData(1);
  }

  restore() {
    this._profile = new BehaviorSubject([]);
    this._page = new BehaviorSubject(1);
    this._total = new BehaviorSubject(0);
    this._loading = new BehaviorSubject(false);
    this._lastPage = new BehaviorSubject(false);
  }

  get profiles() {
    return this._profile.asObservable();
  }

  get currentPage() {
    return this._page.asObservable();
  }

  get getTotal() {
    return this._total.asObservable();
  }

  get loading() {
    return this._loading.asObservable();
  }

  get lastPage() {
    return this._lastPage.asObservable();
  }

  changeFilters(filters: ApplicantFilter, page: number, pagecount?: number) {
    this.filter = filters;
    this.pagecount = pagecount;
    this._loading.next(true);
    this.candidateBackendService.getProfiles(false, filters, page, pagecount)
      .subscribe(
        res => {
          this.page = page;
          this.total = res.pagination.total;
          this._page.next(page);
          this._total.next(this.total);
          this._profile.next(res.profiles);
          this._loading.next(false);
          this._lastPage.next(this.page >= this.maxPages());
        },
        () => {
          console.log("Error retrieving Profiles");
          this._loading.next(false);
        }
      );
  }

  private maxPages() {
    return Math.ceil(this.total / (this.pagecount || 10));
  }

  nextPage(requirement) {
    if(this.page < this.maxPages()) {
        this.changeFilters(this.filter, this.page + 1, this.pagecount);
    }
  }

  prevPage(requirement) {
    if(this.page > 1) {
        this.changeFilters(this.filter, this.page - 1, this.pagecount);
    }
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/state/profile-no-location.store.ts